// @ts-nocheck
import React, { createRef } from "react";
import NormalSpin from "../../../base/basicComponents/spin";
import { dataStatus, actions } from "../../publicDictionaryValues";
import reasonEditDefaultIcon from "../../../assets/image/reasonEditIcon.png";
import styles from "../procedureFileProcess/style/index.module.scss";
import ShareProcessBase from "../../commonComponents/shareProcessBase";
import ReviseChangeMainTaskComplete from "./reviseChangeMainTaskComplete";
import ApproveChangeMainTaskProcess from "./approveChangeMainTask";
import ApproveChangeMainTaskComplete from "./approveChangeMainTaskComplete";
import SubmitChangeMainTaskComplete from "./submitChangeMainTaskComplete";
import ReviseChangeMainTaskProcess from "./reviseChangeMainTask";
import changeMainTaskService from "../../../service/changeMainTask/changeMainTaskService";
import CompleteStepBusinessType from "../../../service/stepBase/completeStepBusinessType";
import StepService from "../../../service/stepBase/StepService";
const procedureReplaceFileRef = createRef();
const procedureRef = createRef();
const procedureServerPathRef = createRef();
const procedureSavedInRef = createRef();
const approvePageRef = createRef();

export default class ChangeMainTaskProcess extends ShareProcessBase {
  constructor(props: any) {
    super(props);
    this.setGlobalVariables();
    this.initChangeMainTaskProcedureFileState();
    // @ts-ignore
    this.procedureFileStepID = null;
    // @ts-ignore
    this.savedInReturnReasonLog = [];
    // @ts-ignore
    this.serverPathReturnReasonLog = [];
    // @ts-ignore
    this.initProcedureTableData = [];
  }

  handleChangeMainTaskPageState = () => {
    return {
      requestByID: null,
      requestByName: null,
      receiveDate: null,
      procedureID: null,
      procedureStepID: null,
      procedureStatus: null,
      isSaveDisabled: false,
      isCancelDisabled: false,
      isSubmitDisabled: false,
      isRejectDisabled: false,
      procedureFolder: {},
      rejectReason: null,
      rejectStatus: null,
      currentRole: null,
      actionName: null,
      loading: false,
      procedureStepStatus: null,
      uploadProcedureFileNum: 0,
      procedureFileNum: 0,
      procedureNote: "",
    };
  };

  initChangeMainTaskProcedureFileState = () => {
    this.state = {
      pageState: this.handleChangeMainTaskPageState(),
      initTableDate: {},
      // @ts-ignore
      savedInSectionState: this.initSavedInSectionState,
      // @ts-ignore
      serverPathSectionState: this.initServerPathSectionState,
      // @ts-ignore
      procedureFileTableState: this.initProcedureFileTableState,
      isReturnReasonLogOpen: false,
      fileTableData: [],
      supportingTableData: [],
      taskInfoData: {},
      procedureInfoData: {},
      procedureFileData: {},
      shareTaskData: {},
      ppoList: [],
      jbProcedureSavedIn: null,
    };
  };

  handleChangeMainTaskSavedInSectionState = (result: any) => {
    return {
      ...this.state.savedInSectionState,
      savedInReturnReasonInputValue:
        result.procedureFolder?.procedureSaveInCategoryReturnReason || null,
      savedInRadioValue: result.procedureFolder?.procedureSaveInCategoryID || null,
      isSavedInReturned:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.return,
      procedureSaveInCategoryStatusID:
        result.procedureFolder?.procedureSaveInCategoryStatusID || null,
      isSavedInApproveBtnDisabled:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.approval,
      isSavedInReturnBtnDisabled:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.return,
    };
  };

  handleChangeMainTaskServerPathSectionStateState = (result: any) => {
    return {
      ...this.state.serverPathSectionState,
      serverPathValue: result.procedureFolder?.clientServerPath || "",
      isServerPathReturned: result.procedureFolder?.clientServerPathStatusID === dataStatus.return,
      serverPathReturnReasonInputValue:
        result.procedureFolder?.clientServerPathReturnReason || null,
      clientServerPathStatusID: result.procedureFolder?.clientServerPathStatusID || null,
      clientServerPathStatusName: result.procedureFolder?.clientServerPathStatusName,
      clientServerPath: result.procedureFolder?.clientServerPath || "",
      isServerPathApproveBtnDisabled:
        result.procedureFolder?.clientServerPathStatusID === dataStatus.approval,
      isServerPathReturnBtnDisabled:
        result.procedureFolder?.clientServerPathStatusID === dataStatus.return,
    };
  };

  setChangeMainTaskSavedInServerPathState = (result: any) => {
    this.setState({
      savedInSectionState: this.handleChangeMainTaskSavedInSectionState(result),
      serverPathSectionState: this.handleChangeMainTaskServerPathSectionStateState(result),
    });
  };

  setChangeMainTaskSavedInReturnReasonLog = (item: any, index: any) => {
    if (
      item.procedureSaveInCategoryStatusID === dataStatus.return &&
      item.actionID === actions.return
    ) {
      // @ts-ignore
      this.savedInReturnReasonLog.push({
        key: index,
        returnedBy: item.auditedByName,
        returnDate: this._formateDate(item.modifiedDate),
        returnReasonColumn: item.procedureSaveInCategoryReturnReason,
      });
    }
  };

  setChangeMainTaskServerPathReturnReasonLog = (item: any, index: any) => {
    if (item.clientServerPathStatusID === dataStatus.return && item.actionID === actions.return) {
      // @ts-ignore
      this.serverPathReturnReasonLog.push({
        key: index,
        returnedBy: item.auditedByName,
        returnDate: this._formateDate(item.modifiedDate),
        returnReasonColumn: item.clientServerPathReturnReason,
      });
    }
  };

  setChangeMainTaskSavedInAndServerPathReturnReasonLog = (list: any) => {
    list.sort((a: any, b: any) => {
      return b.modifiedDate.localeCompare(a.modifiedDate);
    });
    list.forEach((item: any, index: any) => {
      this.setChangeMainTaskSavedInReturnReasonLog(item, index);
      this.setChangeMainTaskServerPathReturnReasonLog(item, index);
    });
  };

  initChangeMainTaskServerPathSectionState = (result: any) => {
    // @ts-ignore
    this.initServerPathSectionState = {
      // @ts-ignore
      ...this.initServerPathSectionState,
      ...this.buildChangeMainTaskServerPathSectionState(result.procedureFolder),
    };
  };

  initChangeMainTaskSavedInSectionState = (result: any) => {
    // @ts-ignore
    this.initSavedInSectionState = {
      // @ts-ignore
      ...this.initSavedInSectionState,
      ...this.buildChangeMainTaskSavedInSectionState(result.procedureFolder),
    };
  };

  initChangeMainTaskPrimitiveServerPathSectionState = (lastStepHistoryData: any) => {
    // @ts-ignore
    this.primitiveServerPathSectionState = {
      // @ts-ignore
      ...this.primitiveServerPathSectionState,
      ...this.buildChangeMainTaskServerPathSectionState(lastStepHistoryData),
    };
  };

  initChangeMainTaskPrimitiveSavedInSectionState = (lastStepHistoryData: any) => {
    // @ts-ignore
    this.primitiveSavedInSectionState = {
      // @ts-ignore
      ...this.primitiveSavedInSectionState,
      ...this.buildChangeMainTaskSavedInSectionState(lastStepHistoryData),
    };
  };

  setInitChangeMainTaskProcedureTableData = () => {
    // @ts-ignore
    this.procedureTableData.forEach((item: any) => {
      // @ts-ignore
      this.initProcedureTableData.push({
        data: JSON.parse(JSON.stringify(item.data)),
        checked: item.checked,
        isApproveDisabled: item.isApproveDisabled,
        isReturnDisabled: item.isReturnDisabled,
        isReturned: item.isReturned,
        isError: item.isError,
        replaceRef: item.replaceRef,
        attachmentEditIcon: reasonEditDefaultIcon,
        isDelete: false,
        isUpdate: false,
      });
    });
  };

  setChangeMainTaskProcedureFileData = (result: any) => {
    if (result.procedureFolder !== null) {
      const historyList = result.procedureFolder?.stepHistoryList.sort((x: any, y: any) =>
        y.modifiedDate.localeCompare(x.modifiedDate)
      );

      this.initChangeMainTaskServerPathSectionState(result);

      this.initChangeMainTaskSavedInSectionState(result);

      if (historyList.length !== 0) {
        const lastStepHistoryData = historyList[0];
        this.initChangeMainTaskPrimitiveServerPathSectionState(lastStepHistoryData);
        this.initChangeMainTaskPrimitiveSavedInSectionState(lastStepHistoryData);
      }

      // @ts-ignore
      this.procedureFileStepID = result.procedureFolder.procedureFileStepID;
      this.setProcedureTableData(result.procedureFolder);
      this.setInitChangeMainTaskProcedureTableData();

      this.setState({
        // @ts-ignore
        fileTableData: this.procedureTableData,
        jbProcedureSavedIn: result.procedureFolder.jbProcedureSaveIn,
      });

      this.setChangeMainTaskSavedInAndServerPathReturnReasonLog(
        result.procedureFolder.stepHistoryList
      );
      this.setChangeMainTaskSavedInServerPathState(result);
    }
  };

  setProcedureFileData = (result: any) => {
    this.setChangeMainTaskProcedureFileData(result);
  };

  /**
   * Build SaveIn Section Data From ProcedureFolder
   * @param {*} data
   * @param {*} isRevise
   * @returns
   */
  buildChangeMainTaskSavedInSectionState = (data: any) => {
    return {
      savedInReturnReasonInputValue: data.procedureSaveInCategoryReturnReason,
      savedInRadioValue: data.procedureSaveInCategoryID,
      isSavedInReturned: data.procedureSaveInCategoryStatusID === dataStatus.return,
      procedureSaveInCategoryStatusID: data.procedureSaveInCategoryStatusID,
      isSavedInApproveBtnDisabled: data.procedureSaveInCategoryStatusID === dataStatus.approval,
      isSavedInReturnBtnDisabled: data.procedureSaveInCategoryStatusID === dataStatus.return,
    };
  };

  /**
   * Build ServerPath Section Data From ProcedureFolder
   * @param {*} data
   * @param {*} isRevise
   * @returns
   */
  buildChangeMainTaskServerPathSectionState = (data: any) => {
    return {
      // @ts-ignore
      ...this.primitiveServerPathSectionState,
      serverPathValue: data.clientServerPath,
      isServerPathReturned: data.clientServerPathStatusID === dataStatus.return,
      serverPathReturnReasonInputValue: data.clientServerPathReturnReason,
      clientServerPathStatusID: data.clientServerPathStatusID,
      clientServerPathStatusName: data.clientServerPathStatusName,
      clientServerPath: data.clientServerPath,
      isServerPathApproveBtnDisabled: data.clientServerPathStatusID === dataStatus.approval,
      isServerPathReturnBtnDisabled: data.clientServerPathStatusID === dataStatus.return,
    };
  };

  _getFlowDataSuccess = (result: any) => {
    const { procedureStepStatus } = result;

    StepService.setStepInterfaceMergePayload(result, {
      isHistorical: procedureStepStatus === "Complete",
      isShareTaskProcess: true,
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    this.getInitData(
      changeMainTaskService.getChangeMainTaskStepItem,
      "Get Change Main Tasks Failed",
      undefined,
      result,
      StepService.getMergePayloadBySettingKey([
        CompleteStepBusinessType.taskInfo.settingKey,
        CompleteStepBusinessType.shareTask.settingKey,
      ])
    );
  };

  _getFlowDataFailed = () => {
    this._alertError("Get Change Main Tasks Failed");
  };

  getFlowData = () => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const param = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };
    changeMainTaskService.getFlowStepData(param, this._getFlowDataSuccess, this._getFlowDataFailed);
  };

  componentDidMount() {
    this.getFlowData();
  }

  /* function about get data from procedure file table */
  changeMainTaskReturnFileDataValue = (name: any, index: any) => {
    // @ts-ignore
    const procedureFileData = procedureRef.current.getDataList();
    // @ts-ignore
    let deleteList = procedureRef.current.getDeleteList();
    let combineDatalist = procedureFileData.concat(deleteList);
    return combineDatalist[index].data.find((item: any) => item.name === name);
  };

  setChangeMainTaskServerPathObj = () => {
    let serverPathValue = null;
    let serverPathStatus = null;
    let serverPathReturnReasonInputValue = null;

    if (procedureServerPathRef.current !== null) {
      const serverPathState =
        // @ts-ignore
        procedureServerPathRef.current.state.serverPathSectionState;
      serverPathValue = serverPathState.serverPathValue;
      serverPathStatus = serverPathState.serverPathStatus;
      serverPathReturnReasonInputValue = serverPathState.serverPathReturnReasonInputValue;
    }

    return {
      serverPathValue: serverPathValue,
      serverPathStatus: serverPathStatus,
      serverPathReturnReasonInputValue: serverPathReturnReasonInputValue,
    };
  };

  changeMainTaskSubmitDataPara = (fileDtos: any, actionID: any, actionName: any) => {
    const serverPathObj = this.setChangeMainTaskServerPathObj();

    const {
      savedInRadioValue,
      procedureSaveInCategoryStatusID,
      savedInReturnReasonInputValue,
      // @ts-ignore
    } = procedureSavedInRef.current.state.savedInSectionState;
    return {
      actionName: actionName,
      actionID: actionID,
      accountID: null,
      // @ts-ignore
      procedureId: this.procedureId,
      // @ts-ignore
      workflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      flowCategoryID: this.flowCategoryID,
      rejectReason:
        approvePageRef.current === null
          ? null
          : // @ts-ignore
            approvePageRef.current.state.pageState.rejectReason,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      // @ts-ignore
      isInitial: this.isRevisePage,
      procedureFiles: fileDtos,
      // @ts-ignore
      procedureFileStepID: this.procedureFileStepID,
      procedureSaveInCategoryID: savedInRadioValue,
      procedureSaveInCategoryStatusID: procedureSaveInCategoryStatusID,
      procedureSaveInCategoryReturnReason: savedInReturnReasonInputValue,
      clientServerPath: serverPathObj.serverPathValue,
      clientServerPathStatusID: serverPathObj.serverPathStatus,
      clientServerPathReturnReason: serverPathObj.serverPathReturnReasonInputValue,
    };
  };

  /* function about return submit data to use in integrate trigger api */
  changeMainTaskHandleReturnSubmitData = (actionID: any, actionName: any) => {
    const fileDtos: any[] = [];
    if (procedureRef.current !== null) {
      // @ts-ignore
      const procedureFileData = procedureRef.current.getDataList();
      // @ts-ignore
      let deleteList = procedureRef.current.getDeleteList();
      let combineDatalist = procedureFileData.concat(deleteList);
      combineDatalist.forEach((item: any, index: any) =>
        fileDtos.push({
          fileID:
            this.changeMainTaskReturnFileDataValue("newVersion", index).fileId === null
              ? this.changeMainTaskReturnFileDataValue("fileId", index).value
              : this.changeMainTaskReturnFileDataValue("newVersion", index).fileId,
          createdDate: this.changeMainTaskReturnFileDataValue("uploadedDate", index).value,
          uploadBy: this.changeMainTaskReturnFileDataValue("uploadById", index).value,
          uploadByName: this.changeMainTaskReturnFileDataValue("uploadByName", index).value,
          fileName:
            this.changeMainTaskReturnFileDataValue("newVersion", index).value === null
              ? this.changeMainTaskReturnFileDataValue("fileName", index).value
              : this.changeMainTaskReturnFileDataValue("newVersion", index).value,
          fileKey: this.changeMainTaskReturnFileDataValue("fileKey", index).value,
          dataStatusID: this.changeMainTaskReturnFileDataValue("status", index).value,
          attachmentFileID: this.changeMainTaskReturnFileDataValue("attachment", index).fileId,
          attachmentName: this.changeMainTaskReturnFileDataValue("attachment", index).value,
          returnReason: this.changeMainTaskReturnFileDataValue("returnReason", index).value,
          fileTagID: this.changeMainTaskReturnFileDataValue("fileName", index).tagValue,
          procedureFileStepID: this.changeMainTaskReturnFileDataValue("procedureFileStepID", index)
            .value,
          procedureFileID: this.changeMainTaskReturnFileDataValue("procedureFileID", index).value,
          note: this.changeMainTaskReturnFileDataValue("note", index).value,
          oldFileID:
            this.changeMainTaskReturnFileDataValue("newVersion", index).fileId === null
              ? null
              : this.changeMainTaskReturnFileDataValue("fileId", index).value,
          oldFileName:
            this.changeMainTaskReturnFileDataValue("newVersion", index).value === null
              ? null
              : this.changeMainTaskReturnFileDataValue("fileName", index).value,
          isDelete: item.isDelete,
          isUpdate: item.isUpdate,
        })
      );
    }

    return this.changeMainTaskSubmitDataPara(fileDtos, actionID, actionName);
  };

  setSupportingFileData = (result: any) => {
    this.setSupportingTableData(result);
    this.setState({
      // @ts-ignore
      supportingTableData: this.supportingTableData,
    });
  };

  setChangeMainTaskPageType = () => {
    this.setSharePageType();
  };

  handleChangeMainTaskPageProps = () => {
    const {
      receiveDate,
      requestByName,
      procedureStepStatus,
      procedureStatus,
      rejectStatus,
      currentRole,
      rejectReason,
    } = this.state.pageState;
    return {
      receiveDate,
      requestByName,
      procedureStepStatus,
      procedureStatus,
      rejectStatus,
      currentRole,
      procedureReplaceFileRef,
      rejectReason,
      // @ts-ignore
      actionID: this.actionID,
    };
  };

  handleChangeMainTaskSectionProps = () => {
    const { taskInfoData, procedureInfoData } = this.state;

    return {
      taskInfoData,
      procedureInfoData,
      ppoList: this.state.ppoList,
    };
  };

  handleChangeMainTaskSavedInProps = () => {
    const {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
    } = this.state.savedInSectionState;

    return {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
      initSavedInStatus:
        // @ts-ignore
        this.initSavedInSectionState.procedureSaveInCategoryStatusID,
      // @ts-ignore
      savedInReturnReasonLog: this.savedInReturnReasonLog,
    };
  };

  handleChangeMainTaskServerPathProps = () => {
    const {
      clientServerPathStatusName,
      serverPathReturnReasonValue,
      serverPathReasonStatus,
      serverPathReturnReasonInputValue,
      clientServerPathStatusID,
      serverPathValue,
    } = this.state.serverPathSectionState;

    return {
      clientServerPathStatusName,
      serverPathReturnReasonValue,
      serverPathReasonStatus,
      serverPathReturnReasonInputValue,
      // @ts-ignore
      serverPathReturnReasonLog: this.serverPathReturnReasonLog,
      clientServerPathStatusID,
      serverPathValue,
    };
  };

  handleChangeMainTaskServerParams = () => {
    return {
      // @ts-ignore
      ProcedureTaskId: this.taskID,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
      // @ts-ignore
      ProcedureFileStepID: this.procedureFileStepID,
      // @ts-ignore
      WorkflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      FlowCategoryID: this.flowCategoryID,
    };
  };

  handleChangeMainTaskRevisePendingPage = (procedureTableData: any) => {
    const { shareTaskData, jbProcedureSavedIn } = this.state;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    return (
      // @ts-ignore
      <ReviseChangeMainTaskProcess
        pageProps={this.handleChangeMainTaskPageProps()}
        params={this.handleChangeMainTaskServerParams()}
        sectionProps={this.handleChangeMainTaskSectionProps()}
        savedInProps={this.handleChangeMainTaskSavedInProps()}
        serverPathProps={this.handleChangeMainTaskServerPathProps()}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        data={procedureTableData}
        supportingTableData={this.state.supportingTableData}
        shareTaskData={shareTaskData}
        updateProcedureFileNum={this.updateProcedureFileNum}
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        fileTableData={procedureTableData}
        jbProcedureSavedIn={jbProcedureSavedIn}
        returnFileDataValue={this.changeMainTaskReturnFileDataValue}
        handleReturnSubmitData={this.changeMainTaskHandleReturnSubmitData}
        primitiveSavedInSectionState={(this as any).primitiveSavedInSectionState}
        primitiveServerPathSectionState={(this as any).primitiveServerPathSectionState}
        closePage={this.closePage}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleChangeMainTaskReviseCompletePage = (procedureTableData: any) => {
    const { taskInfoData, procedureInfoData, shareTaskData, jbProcedureSavedIn } = this.state;

    const { receiveDate, requestByName, procedureStatus, rejectStatus, rejectReason } =
      this.state.pageState;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;
    return (
      <ReviseChangeMainTaskComplete
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        fileTableData={procedureTableData}
        pageProps={{
          receiveDate,
          requestByName,
          procedureStatus,
          rejectReason,
          rejectStatus,
          // @ts-ignore
          actionID: this.actionID,
        }}
        sectionProps={{
          taskInfoData,
          procedureInfoData,
          ppoList: this.state.ppoList,
        }}
        params={this.handleChangeMainTaskServerParams()}
        supportingTableData={this.state.supportingTableData}
        shareTaskData={shareTaskData}
        jbProcedureSavedIn={jbProcedureSavedIn}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleChangeMainTaskApprovePendingPage = (procedureTableData: any) => {
    const { shareTaskData, jbProcedureSavedIn } = this.state;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    return (
      // @ts-ignore
      <ApproveChangeMainTaskProcess
        ref={approvePageRef}
        sectionProps={this.handleChangeMainTaskSectionProps()}
        pageProps={this.handleChangeMainTaskPageProps()}
        serverPathProps={this.handleChangeMainTaskServerPathProps()}
        savedInProps={this.handleChangeMainTaskSavedInProps()}
        params={{
          // @ts-ignore
          ProcedureTaskId: this.taskID,
          // @ts-ignore
          ProcedureID: this.procedureID,
          // @ts-ignore
          ProcedureStepID: this.procedureStepID,
          // @ts-ignore
          ProcedureFileStepID: this.procedureFileStepID,
          // @ts-ignore
          WorkflowProcessInstanceId: this.workflowProcessInstanceId,
          // @ts-ignore
          FlowCategoryID: this.flowCategoryID,
        }}
        data={procedureTableData}
        supportingTableData={this.state.supportingTableData}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        closePage={this.closePage}
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        fileTableData={procedureTableData}
        jbProcedureSavedIn={jbProcedureSavedIn}
        shareTaskData={shareTaskData}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        updateProcedureFileNum={this.updateProcedureFileNum}
        returnFileDataValue={this.changeMainTaskReturnFileDataValue}
        handleReturnSubmitData={this.changeMainTaskHandleReturnSubmitData}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleChangeMainTaskApproveCompletePage = (procedureTableData: any) => {
    const { taskInfoData, procedureInfoData, shareTaskData, jbProcedureSavedIn } = this.state;

    const { receiveDate, requestByName, procedureStatus, rejectStatus, rejectReason } =
      this.state.pageState;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    return (
      <ApproveChangeMainTaskComplete
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        fileTableData={procedureTableData}
        pageProps={{
          receiveDate,
          requestByName,
          procedureStatus,
          rejectReason,
          rejectStatus,
          // @ts-ignore
          actionID: this.actionID,
        }}
        sectionProps={{
          taskInfoData,
          procedureInfoData,
          ppoList: this.state.ppoList,
        }}
        params={this.handleChangeMainTaskServerParams()}
        supportingTableData={this.state.supportingTableData}
        shareTaskData={shareTaskData}
        jbProcedureSavedIn={jbProcedureSavedIn}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleChangeMainTaskSubmitCompletePage = (procedureTableData: any) => {
    const { taskInfoData, procedureInfoData, shareTaskData, jbProcedureSavedIn } = this.state;

    const { receiveDate, requestByName, procedureStatus, rejectStatus, rejectReason } =
      this.state.pageState;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    return (
      <SubmitChangeMainTaskComplete
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        fileTableData={procedureTableData}
        pageProps={{
          receiveDate,
          requestByName,
          procedureStatus,
          rejectReason,
          rejectStatus,
          // @ts-ignore
          actionID: this.actionID,
        }}
        sectionProps={{
          taskInfoData,
          procedureInfoData,
          ppoList: this.state.ppoList,
        }}
        params={this.handleChangeMainTaskServerParams()}
        shareTaskData={shareTaskData}
        supportingTableData={this.state.supportingTableData}
        jbProcedureSavedIn={jbProcedureSavedIn}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  setChangeMainTaskProcedureTableData = () => {
    return JSON.parse(JSON.stringify(this.state.fileTableData));
  };

  render() {
    const procedureTableData = this.setChangeMainTaskProcedureTableData();

    this.setChangeMainTaskPageType();

    return (
      <NormalSpin
        spinning={this.state.pageState.loading}
        size="large"
        indicator={
          this.state.pageState.procedureFileNum > 0 ? (
            <p className={styles.loadingText}>
              Uploading {this.state.pageState.uploadProcedureFileNum}/
              {this.state.pageState.procedureFileNum} file
            </p>
          ) : undefined
        }
        children={
          <>
            {/* @ts-ignore */}
            {this.isRevisePendingPage &&
              this.handleChangeMainTaskRevisePendingPage(procedureTableData)}
            {/* @ts-ignore */}
            {this.isReviseCompletePage &&
              this.handleChangeMainTaskReviseCompletePage(procedureTableData)}
            {/* @ts-ignore */}
            {this.isApprovePendingPage &&
              this.handleChangeMainTaskApprovePendingPage(procedureTableData)}
            {/* @ts-ignore */}
            {this.isApproveCompletePage &&
              this.handleChangeMainTaskApproveCompletePage(procedureTableData)}
            {/* @ts-ignore */}
            {this.isSubmitCompletePage &&
              this.handleChangeMainTaskSubmitCompletePage(procedureTableData)}
          </>
        }
      />
    );
  }
}
